export default __webpack_public_path__ + "static/media/Saravanas Jewellers (2).png.11c12c77.png";